import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { eventsQueryKeys } from 'features/events';
import { UserApiService, VendingDTO } from 'features/vending-machine/api/vending-machine-api.service';
import { queryClient } from 'providers';


const { createVending } = UserApiService();

export const useUpdateVending = () => {
  const { message } = App.useApp();

  return useMutation(
    (payload: VendingDTO) => {
      return createVending(payload as any);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);
        message.error(uiMessage);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: eventsQueryKeys.all,
        });
        message.success("Vending Update successfully");
      },
    },
  );
};
